import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>&copy; 2024 PROCO Co. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
